import * as types from './action-types';

const showAlert = (message, alertType = 'fail') => ({
    type: types.SHOW_ALERT,
    message,
    alertType,
});

const dismissAlert = () => ({
    type: types.DISMISS_ALERT,
});

export default {
    showAlert,
    dismissAlert,
};
